module.exports = __webpack_public_path__ + "img/Webshop.535e5576.svg";